/* esm.sh - html2canvas@1.4.1 */
export * from "/*html2canvas@1.4.1/esnext/html2canvas.mjs";
export { default } from "/*html2canvas@1.4.1/esnext/html2canvas.mjs";
